import { getFunctions, httpsCallable } from "firebase/functions";

class BachsService {
  async payForProduct({ productId, currency = "USD", email, name, roomId = null }) {
    const createCheckout = httpsCallable(getFunctions(), "createBachsCheckout");
    const { data } = await createCheckout({
      productId,
      currency,
      email,
      name,
      roomId,
      origin: window.location.origin,
    });
    if (!data?.checkoutUrl) throw new Error("Could not start checkout. Please try again.");
    return { reference: data.reference, checkoutId: data.checkoutId || null, checkoutUrl: data.checkoutUrl };
  }
}

export const bachsService = new BachsService();
export default bachsService;
